import type { Route } from '~/core/router'

import * as root from '~/routes/no-content/root'
import { keys } from '~/shared/jail'

export const route: Route = {
  keys: [keys.app, keys.guest],

  children: [
    {
      path: '',
      component: root.NoContentPage,
      init: root.model.init,
    },
  ],
}
